import { InformationCircleIcon } from "@heroicons/react/20/solid";
import React, { useEffect } from "react";
// import CustomTooltip from "../customTooltip";
import CountedInput from "./CountedInput";

interface LangTestInputProps {
  id: string;
  label: string;
  onChange: (value: any) => void;
  placeholder?: string;
  maxLength?: number;
  minLength?: number;
  required?: boolean;
  inputClass?: string;
  type?: string;
  error?: string;
  name?: string;
  defaultValue: string;
  helpText?: string;
  description?: string;
  disabled: boolean;
  className?: string;
  disableLength?: boolean;
  minValue?: number;
  maxValue?: number;
  setErrorSubmission?: (value: boolean) => void;
}

const LangTestInput = ({
  id,
  label,
  onChange,
  error,
  name,
  helpText,
  description,
  disabled = false,
  setErrorSubmission = () => {},
  className,
  disableLength = false,
  minValue,
  maxValue,
  required,
  defaultValue,
}: LangTestInputProps) => {
  const values = defaultValue?.split(" ");
  const [readingScore, setReadingScore] = React.useState<number>(0);
  const [writingScore, setWritingScore] = React.useState<number>(0);
  const [listeningScore, setListeningScore] = React.useState<number>(0);
  const [speakingScore, setSpeakingScore] = React.useState<number>(0);
  // const [totalScore, setTotalScore] = React.useState<string>("");

  useEffect(() => {
    const values = defaultValue?.split(" ");

    setReadingScore(values ? parseInt(values[3]) : 0);
    setWritingScore(values ? parseInt(values[5]) : 0);
    setListeningScore(values ? parseInt(values[1]) : 0);
    setSpeakingScore(values ? parseInt(values[7]) : 0);
  }, []);

  useEffect(() => {
    const score =
      "Listening " +
      listeningScore +
      " Reading " +
      readingScore +
      " Writing " +
      writingScore +
      " Speaking " +
      speakingScore;
    console.log(score);

    // setTotalScore(score);.
    onChange({ target: { value: score } });
  }, [listeningScore, readingScore, writingScore, speakingScore]);

  return (
    <>
      <div className="flex justify-initial">
        <label htmlFor={id} className="block text-md  text-my-gray2">
          {label}
        </label>
      </div>
      <div className="grid grid-cols-2 gap-2 my-2">
        <CountedInput
          id=""
          label=""
          helpText="Listening"
          minValue={0}
          maxValue={9}
          type="number"
          onChange={(e: any) => {
            setListeningScore(e.target.value);
          }}
          className="col-span-1"
          placeholder="7"
          disabled={false}
          disableLength={true}
          minLength={1}
          maxLength={5}
          defaultValue={listeningScore?.toString()}
        />
        <CountedInput
          id=""
          label=""
          helpText="Reading"
          minValue={0}
          maxValue={9}
          type="number"
          onChange={(e: any) => {
            setReadingScore(e.target.value);
          }}
          className="col-span-1"
          placeholder="8"
          disabled={false}
          disableLength={true}
          minLength={1}
          maxLength={5}
          defaultValue={readingScore?.toString()}
        />

        <CountedInput
          id=""
          label=""
          helpText="Writing"
          minValue={0}
          maxValue={9}
          type="number"
          onChange={(e: any) => {
            setWritingScore(e.target.value);
          }}
          className="col-span-1"
          placeholder="7.5"
          disabled={false}
          disableLength={true}
          minLength={1}
          maxLength={5}
          defaultValue={writingScore?.toString()}
        />
        <CountedInput
          id=""
          label=""
          helpText="Speaking"
          minValue={0}
          maxValue={9}
          type="number"
          onChange={(e: any) => {
            setSpeakingScore(e.target.value);
          }}
          className="col-span-1"
          placeholder="7"
          disabled={false}
          disableLength={true}
          minLength={1}
          maxLength={5}
          defaultValue={speakingScore?.toString()}
        />
      </div>
    </>
  );
};

export default LangTestInput;
